type PermissionType =
  | 'currency'
  | 'sustain'
  | 'deleteUser'
  | 'analytics'
  | 'onePlanAdmin';

const PERMISSION_MAP: Record<PermissionType, string> = {
  currency: 'CURRENCY',
  sustain: 'SUSTAIN',
  deleteUser: 'DELETE_USER',
  analytics: 'ANALYTICS',
  onePlanAdmin: 'ONE_PLAN_ADMIN',
};

const checkIfAllowed = (
  permissions: string[],
  type: PermissionType,
): boolean => {
  return permissions?.includes(PERMISSION_MAP[type]);
};

export { checkIfAllowed };
